import React, { useEffect, useState } from "react";

const consultingModulesData = [
  {
    stage: "Pathways Overview (60 ECTS Each)",
    modules: [
      {
        title: "Certified Business Consultant Programme (60 ECTS)",
        description: `This pathway focuses on developing expertise in strategic 
        management, financial analysis, marketing, & global business consultancy. 
        Students gain practical skills to address organisational challenges, 
        foster innovation, & drive sustainable growth.`,
      },
      {
        title: "Certified Executive Career Coach Programme (60 ECTS)",
        description: `This pathway emphasises career coaching principles, 
        leadership coaching, advanced organisational behaviour, & ethics. 
        It prepares students to guide individuals & teams in career development 
        & leadership growth.`,
      },
    ],
    importantNote: `Important: 
Students must select one pathway to complete their 60 ECTS before proceeding to the Master’s Stage. 
Detailed module descriptions for each pathway can be accessed through the respective programme pages.`,
  },
  {
    stage: "Compulsory Master’s Modules (30 ECTS)",
    modules: [
      {
        title: "Advanced Strategic Thinking & Problem Solving (5 ECTS)",
        description: `Develop expertise in strategic thinking frameworks 
        & advanced problem-solving techniques to address complex 
        & dynamic organisational challenges.`,
      },
      {
        title: "Leadership in Emerging Global Trends (5 ECTS)",
        description: `Explore leadership strategies to navigate global megatrends, 
        including digital transformation, sustainability, & diversity, 
        fostering innovation & organisational resilience.`,
      },
      {
        title: "Ethics & Governance in Professional Consulting (5 ECTS)",
        description: `Examine ethical considerations & governance frameworks 
        critical to maintaining integrity & accountability in high-stakes 
        consulting environments.`,
      },
      {
        title: "Advanced Global Consulting Strategies (5 ECTS)",
        description: `Master innovative consulting methodologies 
        & strategic approaches to tackle complex organisational challenges. 
        Analyse international consulting models, navigate cross-border dynamics, 
        & apply cultural intelligence to deliver impactful global solutions.`,
      },
      {
        title: "Capstone Professional Consulting Project (10 ECTS)",
        description: `Undertake a practical, real-world project that integrates 
        knowledge & skills from the programme, showcasing advanced 
        consultancy & leadership capabilities.`,
      },
    ],
  },
];

const ConsultingModules = () => {
  const [activeStages, setActiveStages] = useState([0]); 
  const [openModuleIndex, setOpenModuleIndex] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleShowStage = (index) => {
    setActiveStages((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });

    if (isMobile) {
      setTimeout(() => {
        const stageEl = document.getElementById(`stage-${index}`);
        if (stageEl) {
          stageEl.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };
  const toggleModuleDetails = (stageIndex, modIndex) => {
    setOpenModuleIndex((prev) => ({
      ...prev,
      [stageIndex]: prev[stageIndex] === modIndex ? null : modIndex,
    }));
  };

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="modules">
      <div className="max-w-6xl mx-auto p-3 flex flex-col items-center">
        <h2 className="text-center text-2xl font-bold pb-4 border-b-4 border-sdorange inline-block mx-auto">
          Programme Modules
        </h2>

        <div className="sticky top-16 md:top-44 mt-2 mb-4">
          <div
            className="
      bg-blue-100 border-2 border-blue-500 p-2 rounded-md
      flex flex-col md:flex-row
      space-y-2 md:space-y-0 md:space-x-4
      items-center justify-center
    "
          >
            {consultingModulesData.map((stageData, idx) => (
              <button
                key={idx}
                onClick={() => handleShowStage(idx)}
                className="bg-sddarkorange text-white py-1 px-2 rounded text-sm"
              >
                {stageData.stage}
              </button>
            ))}
          </div>
        </div>
        <div
          className={
            isMobile
              ? "space-y-6" 
              : "flex space-x-6 overflow-x-auto" 
          }
        >
          {activeStages.map((stageIndex) => {
            const currentStage = consultingModulesData[stageIndex];
            const { stage, modules, importantNote } = currentStage;

            return (
              <div
                key={stageIndex}
                id={`stage-${stageIndex}`}
                className="min-w-[300px] scroll-mt-44 max-w-sm border-2 rounded-md bg-gray-400 bg-opacity-50 border-sdorange p-4"
              >
                <h3 className="text-xl font-semibold mb-2">{stage}</h3>

                {importantNote && (
                  <div className="mb-4 text-sm border-2 border-white text-white bg-red-700 p-2 rounded shadow">
                    {importantNote}
                  </div>
                )}

                {modules.map((mod, modIndex) => {
                  const isOpen = openModuleIndex[stageIndex] === modIndex;
                  return (
                    <div key={modIndex} className="mb-3">
                      <button
                        onClick={() =>
                          toggleModuleDetails(stageIndex, modIndex)
                        }
                        className="flex justify-between items-center w-full px-2 py-1 bg-sdorange rounded text-gray-700 hover:bg-orange-400 hover:text-black"
                      >
                        <div className="flex items-center space-x-2">
                          <img
                            src="/image-fix/academic-programmes/certified-courses/icons/play-circle-svgrepo-com.svg"
                            alt="Play Icon"
                            className="h-4 w-4"
                          />
                          <span className="font-semibold text-sm">
                            {mod.title}
                          </span>
                        </div>
                        <span>
                          {isOpen ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 15l7-7 7 7"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          )}
                        </span>
                      </button>
                      {isOpen && (
                        <div className="mt-2 p-2 bg-sdbodywhite rounded shadow text-sm text-gray-700">
                          <p>{mod.description}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ConsultingModules;
